module.exports = __webpack_public_path__ + "813340fedab60cc85cdeefc6ae87b1aa.png";